import { AttestationContent } from "./attestation-content";

export class AttestationBody {
    titreAttestation?: string;
    numeroDemande?: string;
    validite?: string;
    content?: AttestationContent;
}
